// Builds an HTML fragment representing a Recipe doc from PouchDB,
// suitable for injection into the offline modal. Intentionally minimal —
// not visual parity with the full server-rendered recipe page; just
// enough to follow a recipe while disconnected (title, ingredients,
// directions). Uses Tailwind utilities consistent with the rest of
// the app so it doesn't look out of place.

function escapeHtml(value) {
  if (value === null || value === undefined) return ""
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

function ingredientLine(ing) {
  // Imports store "unit" for counted things ("3 unit eggs"); never show it.
  const unit = /^\s*unit\s*$/i.test(ing.unit || "") ? null : ing.unit
  const parts = [ing.quantity, unit, ing.name].filter(p => p && String(p).trim().length)
  return parts.map(escapeHtml).join(" ")
}

export function renderOfflineRecipe(doc = {}) {
  const ingredients = Array.isArray(doc.ingredients) ? doc.ingredients : []
  const directions = Array.isArray(doc.directions) ? doc.directions : []

  const ingredientItems = ingredients
    .map(i => `<li class="text-gray-700 dark:text-gray-300">${ingredientLine(i)}</li>`)
    .join("")

  const directionItems = directions
    .map(d => `<li class="text-gray-700 dark:text-gray-300 leading-relaxed">${escapeHtml(d.instruction)}</li>`)
    .join("")

  return `
    <div class="px-4 sm:px-6 py-4">
      <p class="mb-3 inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-amber-700 dark:text-amber-400">
        <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        Viewing offline copy
      </p>
      <h1 class="font-display text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">${escapeHtml(doc.title)}</h1>
      ${doc.description ? `<p class="mt-2 text-sm text-gray-600 dark:text-gray-400">${escapeHtml(doc.description)}</p>` : ""}
      <h2 class="mt-6 font-display text-lg font-semibold text-gray-900 dark:text-white">Ingredients</h2>
      <ul class="mt-2 space-y-1.5 list-disc list-inside text-sm">${ingredientItems}</ul>
      <h2 class="mt-6 font-display text-lg font-semibold text-gray-900 dark:text-white">Directions</h2>
      <ol class="mt-2 space-y-2.5 list-decimal list-inside text-sm">${directionItems}</ol>
    </div>
  `
}
